// src/utils/api.js

const BASE_URL =
  'https://services6.arcgis.com/hM5ymMLbxIyWTjn2/arcgis/rest/services/2024_Mississauga_Business_Directo/FeatureServer/0/query';

const PAGE_SIZE = 1000;  // max number of records to fetch per request
const COMMON_PARAMS = {
  where:          '1=1',
  outFields:
    'FID,PIN,Name,Phone,Fax,Tollfree,EMail,WebAddres,StreetNo,StreetName,BuildingNo,UnitNo,PostalCode,Ward',
  returnGeometry: 'false',
  outSR:          '4326',
  f:              'json',
  orderByFields:  'FID'
};

export async function fetchBusinessesData() {
  let allFeatures = [];
  let offset = 0;

  while (true) {
    // build URLSearchParams for this “page”
    const params = new URLSearchParams({
      ...COMMON_PARAMS,
      resultRecordCount: PAGE_SIZE.toString(),
      resultOffset:      offset.toString()
    });

    const url = `${BASE_URL}?${params}`;
    console.log(`[fetchBusinessesData] fetching page @ offset ${offset}:`, url);

    const resp = await fetch(url);
    if (!resp.ok) {
      throw new Error(`Fetch failed: ${resp.status} ${resp.statusText}`);
    }

    const json = await resp.json();
    if (json.error) {
      throw new Error(`ArcGIS error: ${json.error.message}`);
    }

    const features = json.features || [];
    console.log(
      `[fetchBusinessesData] got ${features.length} records (offset ${offset})`
    );

    allFeatures.push(...features);

    // if we got fewer than PAGE_SIZE, that was the last page
    if (features.length < PAGE_SIZE) break;

    offset += PAGE_SIZE;
  }

  console.log(
    `[fetchBusinessesData] total records fetched: ${allFeatures.length}`
  );
  return allFeatures;
}
